import './MenuPage.scss'
import {t} from "i18next";

const MenuPage = (props) => {
  const {
    onChangeView,
    lastScreenInGame,
    menuVolume,
    setMenuVolume,
    menuFxVolume,
    setMenuFxVolume,
    onChangeLanguage,
    curLanguage,
  } = props

  const onSelectMenu = () => {

  }

  return <div className="MenuPage">
    <div className="MenuPage-header"><h2>{t('menu-title')} </h2></div>
    <div className="MenuButtons">
      {lastScreenInGame !== '' && <button onClick={() => onChangeView(lastScreenInGame)}> {t('menu-continue')} </button>}
      <button onMouseEnter={()=>onSelectMenu()} onClick={()=>onChangeView("NewGamePage")}> {t('menu-new-game')} </button>
      <button onMouseEnter={()=>onSelectMenu()} onClick={()=>onChangeView("CreditsPage")}> {t('menu-credits')} </button>
      <button onMouseEnter={()=>onSelectMenu()} onClick={()=>onChangeView("ExitPage")}> {t('menu-close')} </button>
    </div>
    <div className="MenuPage-language"> <button onClick={()=>onChangeLanguage()}><div className="bage"> {curLanguage === 0 ? "EN" : "Рус"} </div></button> </div>
    <div className="MenuPage-volume">
      <div className='section'>
        <div>{t('menu-music')}: {Math.round(menuVolume * 100)}%</div>
        <div><input
          className="volumeChanger"
          type="range"
          defaultValue={menuVolume}
          onChange={(e)=>setMenuVolume(e.currentTarget.value)}
          min={0}
          max={1}
          step={0.01}
        /></div>
      </div>
      <div className='section'>
        <div>{t('menu-sounds')}: {Math.round(menuFxVolume * 100)}%</div>
        <div><input
          className="volumeChanger"
          type="range"
          defaultValue={menuFxVolume}
          onChange={(e)=>setMenuFxVolume(e.currentTarget.value)}
          min={0}
          max={1}
          step={0.01}
        /></div>
      </div>
    </div>
  </div>
}

export default MenuPage